/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#scrollViewUpdated__anchor
 */
export default () => {
  window.documentViewer.scrollViewUpdated();
};
